import { render, staticRenderFns } from "./InstrumentoTabList.vue?vue&type=template&id=03477f63&scoped=true"
import script from "./InstrumentoTabList.vue?vue&type=script&lang=js"
export * from "./InstrumentoTabList.vue?vue&type=script&lang=js"
import style0 from "./InstrumentoTabList.vue?vue&type=style&index=0&id=03477f63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03477f63",
  null
  
)

export default component.exports